import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

/**
 * Collapsible reference section for the CRM patient modal (2026-08-25).
 *
 * No-data-loss mechanism: children are ALWAYS MOUNTED and the body is
 * hidden with CSS (`hidden`), never unmounted. Collapsing a section that
 * holds an in-progress edit and re-expanding it therefore preserves the
 * typed value and any inline-edit state — collapse is presentation only.
 *
 * Default state is CLOSED on every mount, and mount happens on every
 * modal open, so there is deliberately no expand-state persistence.
 */
export function CollapsibleSection({ id, title, icon: Icon, children, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div
      className="col-span-2 rounded-xl border border-slate-200 bg-white overflow-hidden"
      data-testid={`crm-section-${id}`}
    >
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className="w-full flex items-center justify-between gap-2 px-3 py-2.5 text-left hover:bg-slate-50 transition-colors"
        data-testid={`crm-section-toggle-${id}`}
      >
        <span className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-slate-600">
          {Icon && <Icon size={14} className="text-slate-400" />}
          {title}
        </span>
        <ChevronDown
          size={16}
          className={`text-slate-400 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>
      <div
        className={open ? "px-3 pb-3" : "hidden"}
        aria-hidden={!open}
        data-testid={`crm-section-body-${id}`}
      >
        {children}
      </div>
    </div>
  );
}

export default CollapsibleSection;
